import React, { useState } from "react";
import TestPage from "./TestPage";

const TestPages = ({
  testPages,
  pageNumber,
  pageType,
  testType,
  candidate,
  renderNextPage,
  renderPreviousPage,
  TestsPageJump,
  //
  storedAnswers,
  setStoredAnswers,
  writingAnswerNote,
  setWritingAnswerNote,
  // 已答題號與 Review 標記由 App 保管——續考要把它們一起存進度、一起還原
  answeredQuestion,
  setAnsweredQuestion,
  reviewModeNode,
  setReviewModeNode,
  splitRatio,
  setSplitRatio,
  fontScale,
}) => {
  const [chosenQuestion, setChosenQuestion] = useState(1);
  const [reviewChecked, setReviewChecked] = useState(false);
  const [chooseQForCheckbox, setChooseQForCheckbox] = useState(5);

  const currentPageIndex = pageNumber - 4;
  return testPages.map((testPage, index) => (
    <TestPage
      key={index}
      display={pageType === "Tests" && index === currentPageIndex}
      pageSeq={index + 1}
      pages={testPages}
      page={testPage}
      testType={testType}
      chosenQuestion={chosenQuestion}
      setChosenQuestion={setChosenQuestion}
      answeredQuestion={answeredQuestion}
      setAnsweredQuestion={setAnsweredQuestion}
      renderNextPage={renderNextPage}
      renderPreviousPage={renderPreviousPage}
      TestsPageJump={TestsPageJump}
      reviewChecked={reviewChecked}
      setReviewChecked={setReviewChecked}
      reviewModeNode={reviewModeNode}
      setReviewModeNode={setReviewModeNode}
      chooseQForCheckbox={chooseQForCheckbox}
      setChooseQForCheckbox={setChooseQForCheckbox}
      storedAnswers={storedAnswers}
      setStoredAnswers={setStoredAnswers}
      writingAnswerNote={writingAnswerNote}
      setWritingAnswerNote={setWritingAnswerNote}
      splitRatio={splitRatio}
      setSplitRatio={setSplitRatio}
      fontScale={fontScale}
    />
  ));
};

export default TestPages;
